module.exports = __webpack_public_path__ + "static/media/music-alt-slash.431ab960.svg";